import { FC } from 'react';
import { Button, Link } from '@marriott/mi-ui-library';
import { TermsLinkComponentProps } from './ConsentCheckListItem.types';
import clsx from 'clsx';

export const TermsLinkComponent: FC<TermsLinkComponentProps> = ({
  termsLink,
  termsBtnLabel,
  openAccordionBtnLabel,
  linkClass,
  target,
  onLinkClick,
  onAccordionToggle,
  isDefaultTermsLink = false,
  isNewTabTermsLink = false,
  shouldDisplayShowMoreButton = false,
}: TermsLinkComponentProps) => {
  const className = linkClass || '';

  if (isDefaultTermsLink && termsLink) {
    return (
      <Link
        linkHref={termsLink}
        linkClassName={className}
        target={target}
        text={termsBtnLabel!}
        callback={onLinkClick}
      />
    );
  }

  if (isNewTabTermsLink && termsLink) {
    return <Link linkHref={termsLink} linkClassName={className} text={termsBtnLabel!} />;
  }

  if (shouldDisplayShowMoreButton) {
    return (
      <Button
        className={clsx('t-font-s t-display-1 term-link-accordion-button', className)}
        callback={onAccordionToggle}
      >
        {openAccordionBtnLabel}
      </Button>
    );
  }

  return <></>;
};
